export const USERS_ROUTES = {
  __ROOT__: '/users',
  EDIT_USER: '/users/edit/:userId',
  NEW_USER: '/users/new',
  VIEW_USER: '/users/view/:userId',
}
